// All properties sorted alphabetically.
export enum SlugPrefix {
  category = 'category',
  offer = 'offer',
  qaSet = 'question',
  subCategory = 'category',
}
